export const INTERNATIONAL_CONFIG_SAVE_SUCCESS_MESSAGE =
  'Your international configurations settings were saved successfully.';
export const INTERNATIONAL_CONFIG_SAVE_ERROR_MESSAGE =
  'Your international configurations settings were not saved successfully. Try again.';
export const INTERNATIONAL_CONFIG_SAVE_SUCCESS_TITLE = 'Success!';
export const INTERNATIONAL_CONFIG_SAVE_ERROR_TITLE = 'Something Went Wrong!';
